import React from "react";
import SideBar from "./SideBar";
import NavHeader from "./NavHeader";
import Header from "./Header";

// Lean back-office nav: brand header + sidebar + top bar. The clinical app's
// chat/mentions/help drawers are intentionally omitted.
const JobieNav = () => (
   <>
      <NavHeader />
      <SideBar />
      <Header />
   </>
);

export default JobieNav;
